import $ from 'jquery';

export default class Utils {

  /**
   * FixBodyPaddingTop
   * a11y: for safety we do exactly the thing we do in CSS: the topbanner top position is equal to header height
   * and the body padding-top is equal to header height + topbanner height
   * useful if user zoom text more than 200%
   * ONLY for desktop !!!! if mobile set to 0
   */
  static fixBodyPaddingTop() {
    const topBanner = document.querySelector('.top-banner');
    const header = document.querySelector('.header');
    const body = document.body;

    if (window.innerWidth > this.breakpoints.md && topBanner) {
      topBanner.style.top = `${this.outerHeight(header)}px`;
      body.style.paddingTop = `${this.outerHeight(header) + this.outerHeight(topBanner)}px`;
    } else {
      body.style.paddingTop = 0;
    }
  }

  /**
   * VIEWPORT HEIGHT FIX from https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
   */
  static vhFix() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const unitMultiple = 0.01;
    const vh = window.innerHeight * unitMultiple;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  /**
   * Checks the IE version
   *
   * @returns {number}
   */
  static checkIEversion() {
    // Return value assumes failure.
    let rv = -1;
    const ie11Rv = 11;
    const ieEdgeRv = 12;

    if (navigator.appName === 'Microsoft Internet Explorer') {
      const ua = navigator.userAgent,
        re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');

      if (re.exec(ua) !== null) {
        rv = parseFloat(RegExp.$1);
      }
    } else if (navigator.appName === 'Netscape') {
      /// in IE 11 the navigator.appVersion says 'trident'
      /// in Edge the navigator.appVersion does not say trident
      if (navigator.appVersion.indexOf('Trident') === -1) {
        rv = ieEdgeRv;
      } else {
        rv = ie11Rv;
      }
    } else {
      // Not IE, do nothing
    }
    return rv;
  }

  /**
   * Calculates the total height of an element
   *
   * @param el
   * @returns {number}
   */
  static outerHeight(el) {
    let height = el.offsetHeight;
    const style = getComputedStyle(el);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
  }

  static headerHeight() {
    const header = document.querySelector('.header');
    return this.outerHeight(header);
  }

  /**
   * Checks if browser is IE
   *
   * @returns {boolean}
   */
  static get isIE() {
    return this.checkIEversion() === 11 || this.checkIEversion() === 10;
  }

  /**
   * Checks if browser is Safari
   *
   * @returns {boolean}
   */
  static get isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  /**
   * Checks if browser is Edge
   *
   * @returns {*|boolean}
   */
  static get isEdge() {
    return !this.isIE && (document.documentMode || /Edge/.test(navigator.userAgent));
  }


  /**
   * breakpoints based on https://getbootstrap.com/docs/4.3/layout/grid/
   *
   * @returns {{xl: number, md: number, sm: number, xs: number, lg: number}}
   */
  static get breakpoints() {
    return {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1300,
    };
  }


  static get isXLScreen() {
    return window.innerWidth >= this.breakpoints.xl;
  }
  static get isMobile() {
    return window.innerWidth < this.breakpoints.md;
  }
  static get isTablet() {
    return window.innerWidth < this.breakpoints.lg;
  }

  /**
   * Adds characters at the beginning of a string
   *
   * @param n
   * @param width
   * @param z
   * @returns {string}
   */
  static pad(n, width, z) {
    z = z || '0';
    n = n.toString();
    let returnValue = n;
    if (n.length <= width) {
      returnValue = [].slice.call({
        length: width - n.length + 1
      }).join(z) + n;
    }
    return returnValue;
  }

  /**
   * Checks if a variable is undefined (true if undefined, false if defined)
   *
   * @param e
   * @returns {boolean}
   */
  static isUndefined(e) {
    return typeof e === 'undefined';
  }

  /**
   * Returns the number of visible height is available in the current page
   *
   * @returns {number}
   */
  static scrollbarHeight() {
    return window.innerHeight * (window.innerHeight / document.body.offsetHeight);
  }

  /**
   * Returns the scrollbar postion with its height
   *
   * @returns {number}
   */
  static scrollbarPosition() {
    const windowScrollTop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
    return windowScrollTop + window.innerHeight + this.scrollbarHeight();
  }


  /**
   * Checks if an element is visible
   *
   * @param e
   * @returns {boolean}
   */
  static elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top >= window.pageYOffset &&
      left >= window.pageXOffset &&
      (top + height) <= (window.pageYOffset + window.innerHeight) &&
      (left + width) <= (window.pageXOffset + window.innerWidth)
    );
  }

  /**
   * getCookie
   *
   * @param cname
   * @returns {string}
   */
  static getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  /**
   * setCookie
   *
   * @param name
   * @param value
   */
  static setCookie(name, value, expiration) {
    document.cookie = name + '=' + value + (expiration? ';expires=' + expiration:'');
  }

  /**
   *
   * @param {string} id
   * @param {function} callback called at scroll end
   */

  static goToHash(id, callback){
    const $target = $(`#${id}`);
    if(!$target.length){
      return;
    }
    const positionY = $target.offset().top - $('.header').height() - 40;

    $('html, body').animate({
      scrollTop: positionY,
    }, 300, () => {
      setTimeout(() => {
        if(callback){
          callback();
        }
      }, 0);

    });
  }
}
